import { IonIcon } from '@ionic/react'
import { flash } from 'ionicons/icons'
import React from 'react'
import useUser from '../../../../contexts/hooks/useUser'
import { getMonthString } from '../../../../modules/consumptionDataParser'

interface Props {
	consideredMonth: any
	comparisonMonth: any
}

const ConsumptionCircle: React.FC<Props> = ({ consideredMonth, comparisonMonth }) => {
	const { user } = useUser()

	return (
		<div className='slide-container'>
			<div id='circle' className='bg-white dark:bg-background-200-dark'>
				<div
					id='inner'
					className='bg-white dark:bg-background-200-dark text-text-dark dark:text-text-light'
				>
					<IonIcon
						icon={flash}
						className='text-brand-primary-100-light mb-1 dark:text-brand-primary-100-dark'
					/>
					<span className='current-month-title'>
						{getMonthString(consideredMonth.localTime.month, user?.language)}
					</span>
					<span className='main-value'>
						{Math.round(consideredMonth.kwh)}
						<span className='unit text-text-grey-300 dark:text-text-grey-100'>kWh</span>
					</span>
					{comparisonMonth.kwh > 0 && (
						<div className='bottom'>
							{getMonthString(comparisonMonth.localTime.month, user?.language)}{' '}
							{comparisonMonth.localTime.month === consideredMonth.localTime.month && (
								<>
									{comparisonMonth.localTime.year} <br />
								</>
							)}
							{Math.round(comparisonMonth.kwh)} kWh
						</div>
					)}
				</div>
			</div>
		</div>
	)
}
export default ConsumptionCircle
